/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_JTvPo26d6",
    "aws_user_pools_web_client_id": "5aue52abe1bmcgeqobepqloqhh",
    "oauth": {},
    "aws_cognito_username_attributes": ["EMAIL"],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": ["EMAIL"],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": ["EMAIL"],
    "aws_appsync_graphqlEndpoint": "https://ocw5dfdelfhmhnprvtozmtxedu.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ff5mvpkayfhc3g26ix5s424vwe",
    "API": {
        "GraphQL": {
            "endpoint": "https://ocw5dfdelfhmhnprvtozmtxedu.appsync-api.us-west-1.amazonaws.com/graphql",
            "region": "us-west-1",
            "defaultAuthMode": "apiKey",
            "apiKey": "da2-ff5mvpkayfhc3g26ix5s424vwe"
        }
    }
};


export default awsmobile;
